import { Button, CircularProgress, FormControl, Grid, makeStyles, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import CachedIcon from '@material-ui/icons/Cached';
import VisibilityIcon from '@material-ui/icons/Visibility';
import moment from "moment";
import clsx from 'clsx';
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Pagination } from "@material-ui/lab";
import { fetchProjectStructuredData } from "../../../../../containers/actions/common/projectActions";
import Search from "../../../grnReceipts/Search";
import { PROJECT_STRUCTURED_DATA } from "../../../../../containers/actions/types";
import { presentFormatedData } from "../../../functionalComponents/dataFormatFunctions";
import ViewBatchStructuredReport from "./ViewBatchStructuredReport";
import PaginationInput from "../../../models/pagination/PaginationInput";

const useStyles = makeStyles((theme) => ({

  refreshContainerSty:{display: 'flex', justifyContent: 'flex-end',
    [theme.breakpoints.down('sm')]: {
      justifyContent: 'flex-start',
      paddingTop: '1rem',
    },
    [theme.breakpoints.down('xs')]: {
      paddingTop: '1rem',
    },
  },
  refreshSty:{display: 'flex',alignItems: 'center',cursor: 'pointer','&:hover': {
    textDecoration: 'underline',
  }},
  padR20: {
    paddingRight: 20,
    [theme.breakpoints.down('xs')]: {
      paddingRight: 0,
    },
  },
  hgText: {
    fontWeight: 500,
    paddingRight: theme.spacing(1),
  },
  outlined: {
    padding: theme.spacing(1),
  },
  formControl: {
    minWidth: 120,
    fontSize: '0.875rem',
  },
  formPerPage: {
    minWidth: 60,
    fontSize: '0.875rem',
  },
  upload: {
    background:
      'transparent linear-gradient(251deg, #173072 0%, #301232 100%) 0% 0% no-repeat padding-box;',
    color: 'white',
    textTransform: 'none',
    borderRadius: '2rem',
    // marginRight: 20,
    padding: '5px 20px',
    '&:hover': {
      backgroundColor: 'green',
      background: 'green',
      color: 'white',
    },
  },
  multipleLogo: {
    border: '1px solid #7d7c7c',
    borderRadius: '4px',
    padding: '0.3rem',
    height: 'inherit',
    marginLeft: '0.5rem',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: 'black',
      color: 'white',
      border: '1px solid #FFF',
    },
  },
  clickableTextSty: {
    '&:hover': {
      textDecoration: 'underline',
    color: '#2196F3',
    cursor: 'pointer'
    },
  }
}))

const StructuredData = () => {
  const classes = useStyles();
  const history = useHistory();
  const dispatch = useDispatch();
  const [searchQuery, searchQueryInput] = useState('');
  const [tempSearch, tempSearchQury] = useState('');
  const [noRowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(1);
    const [error, setError] = useState('')
  const [openView, setOpenView] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState();
  let loading = true;

  useEffect(() => {
    // Fetch projects from API
    dispatch({
      type: PROJECT_STRUCTURED_DATA,
      payload: undefined
    })
    dispatch(fetchProjectStructuredData());
  }, [dispatch]);

  const handleRefresh = () => {
    dispatch({
      type: PROJECT_STRUCTURED_DATA,
      payload: undefined
    })
    loading = true;
    setError('')
    dispatch(fetchProjectStructuredData());
  }


  const handleSearchQuery = (event) => {
    let { value } = event.target;
    if (value === '' || value === null) {
      tempSearchQury(value);
      searchQueryInput('');
    } else {
      tempSearchQury(value);
    }
  };

  const handleClearSearch = (event) => {
    event.preventDefault();
    tempSearchQury('');
    searchQueryInput('');
  };

  const submitSearch = (event) => {
    event.preventDefault();
    searchQueryInput(tempSearch.trim());
  };

  const handleSetRows = (event) => {
    setRowsPerPage(event.target.value);
    setCurrentPage(1);
  };

  const handlePageChange = ( page) => {
    setCurrentPage(page);
    };
    
    const handleCloseDialog = () => {
        setOpenView(false)
    }
  const handleOpenDialog = (row) => {
    setSelectedBatch(row)
      setOpenView(true)
      
     }


  // Function to render projectStatus button with correct color based on projectStatus
  const rows = useSelector((state) => {
    if (state.pcmp.common.Projects?.projectStructuredData?.status === true) {
      if (loading) {
        loading = false
      }
      return state.pcmp.common.Projects.projectStructuredData.data
    } else if (state.pcmp.common.Projects?.projectStructuredData?.status === false) {
      if (loading) {
        loading = false
      }
      if (error === '') {
      setError('Something went wrong. Please try again later.')
      }
      return []
     }
    else {
      return [];
    }
  });

  let totalPages = Math.ceil(rows.length / noRowsPerPage);
  
  let records = currentPage * noRowsPerPage;

  const projectsList = rows
  ? rows.slice(records - noRowsPerPage, records)
  : [];

let pages = rows
  ? Math.ceil(rows.length / noRowsPerPage)
  : null;

  let noPages = pages ? pages : 1;

  return (
    <React.Fragment>
      <Grid container alignItems='center' style={{ paddingBottom: '0.5rem', paddingTop: '1rem' }} >
        <Grid item xs={12} sm={10} md={6}>
        <Typography variant='body2' style={{fontWeight: 500}}>
          Filter By:
        </Typography>
          <Search
            searchQuery={tempSearch}
            // handleSearchQuery={handleSearchQuery}
            handleClearSearch={handleClearSearch}
            submitSearch={submitSearch}
            placeholder={'Search using Compound ID, Type of Batch'}
          />
          </Grid>
        <Grid item xs={12} md={6}>
          <Grid
            container
            className={classes.refreshContainerSty}
          >
            <Typography variant='caption' className={clsx(classes.padR20)}>
              {`Last synced @ ${moment(new Date()).format(
                'HH:mm:ss; DD MMMM, YYYY'
              )}`}
            </Typography>

            <Typography
              variant='caption'
              color='primary'
              className={classes.refreshSty}
              onClick = {handleRefresh}
            >
              Refresh
              <CachedIcon color='primary' style={{ fontSize: 15 }} />
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container alignItems='center' justifyContent="flex-end" >
        <Grid item>
        <Typography variant='body2' className={classes.hgText}>
        PER PAGE
      </Typography>
      <FormControl className={classes.formPerPage}>
        <Select
          labelId='perpage-filter'
          id='perpage-filter-id'
          value={noRowsPerPage}
          variant='outlined'
          onChange={handleSetRows}
          classes={{
            outlined: classes.outlined,
          }}
        >
          <MenuItem value={3}>3</MenuItem>
          <MenuItem value={5}>5</MenuItem>
          <MenuItem value={10}>10</MenuItem>
          <MenuItem value={15}>15</MenuItem>
          <MenuItem value={30}>30</MenuItem>
        </Select>
      </FormControl>
        </Grid>
      </Grid>
      <TableContainer component={Paper} style={{ marginTop: 20 }}>
        <Table>
          <TableHead>
            <TableRow>
                          <TableCell align="left">Compound ID</TableCell>
                          <TableCell align="left">Type of Batch</TableCell>
              {localStorage.collabType !== 'CMO' && <TableCell align="left">CMO</TableCell>}
              <TableCell align="left">Plant ID</TableCell>
              <TableCell align="left">Start Date</TableCell>
                          <TableCell align="left">Batch Number</TableCell>
                          <TableCell align="left">MBR number</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
          {loading === true && (
                  <TableRow style={{ height: 150 }}>
                    <TableCell colSpan={8}>
                      <div style={{ textAlign: 'center' }}>
                        <CircularProgress color='primary' />
                      </div>
                    </TableCell>
                  </TableRow>
                )}
            {loading === false && error === '' && (projectsList.length > 0 ? projectsList.map((row, index) => (
              <TableRow key={index}>
                <TableCell align="left">
                    {presentFormatedData(row.projectName)}
                    </TableCell>
                    <TableCell align="left">{presentFormatedData(row.batchType)}</TableCell>
                {localStorage.collabType !== 'CMO' && <TableCell align="left">{presentFormatedData(row.cdmoOrgName)}</TableCell>}
                <TableCell align="left">{presentFormatedData(row.plantID)}</TableCell>
                <TableCell align="left">{row?.batchStartDate ? moment(row.batchStartDate).format('DD-MMM-YYYY'):'-NA-'}</TableCell>
                    <TableCell align="left">{presentFormatedData(row.batchNumber)}</TableCell>
                    <TableCell align="left">{presentFormatedData(row.numberBMR)}</TableCell>
                <TableCell align="center"><VisibilityIcon
        fontSize='small'
                        className={classes.multipleLogo}
                        onClick={()=>handleOpenDialog(row)}
      /></TableCell>
              </TableRow>
            )): <TableRow>
            <TableCell
              colSpan={8}
              align='center'
            >
              No Records Found
            </TableCell>
            </TableRow>)}
            {loading === false && error !=='' && (<TableRow style={{border: '2px solid #FF0000',
                backgroundColor: '#FFF0F0',}}><TableCell
              colSpan={8}
              align='center'
              
            >
              Something went wrong. Please try again later.
            </TableCell>
            </TableRow>)}
          </TableBody>
        </Table>
      </TableContainer>
      <Grid
          container
          alignItems='center'
          justifyContent='center'
          style={{ paddingTop: '1rem' }}
        >
          {/* <Pagination
            page={currentPage}
            name='currentPage'
            onChange={(event, page) => handlePageChange(event, page)}
            count={noPages}
            variant='outlined'
            shape='rounded'
          /> */}
        <PaginationInput
          totalPages={totalPages}
          handlePageChange={handlePageChange}
          page={currentPage}
        />
        </Grid>

        {openView && (
        <ViewBatchStructuredReport
                  openDialog={openView}
          handleClose={handleCloseDialog}
          batch={selectedBatch}
        />
        )}
    </React.Fragment>
  );
};

export default StructuredData;
